import { Navigate } from 'react-router-dom';

/** Legacy route — MCP catalog is managed from Global Tools → MCP Endpoints drawer. */
const McpEndpointCatalogAdmin = () => <Navigate to="/admin/global-tools" replace />;

export default McpEndpointCatalogAdmin;
